import React, { useState } from 'react';

export default function FAQPage() {
  const faqData = [
    {
      question: 'What services do you offer?',
      answer:
        'We offer modern architecture, interior design, and other customized services tailored to your needs.',
    },
    {
      question: 'How can I get a quote?',
      answer:
        'You can contact us via the Contact page or email us directly. We provide free initial consultations and quotes.',
    },
    {
      question: 'What is your project timeline?',
      answer:
        'Timelines vary depending on the scope of the project. Typically, small projects take 2-4 weeks, while larger ones may take 3-6 months.',
    },
    {
      question: 'Do you provide after-service support?',
      answer:
        'Yes! We provide maintenance and support even after project completion to ensure your satisfaction.',
    },
    {
      question: 'Are your services available nationwide?',
      answer:
        'Currently, we operate in selected regions. Please contact us to check availability in your area.',
    },
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="w-full">

      {/* Banner Section */}
      <section className="relative h-[50vh] bg-gray-800 flex items-center justify-center">
        <img
          src="/images/aboutus/aboutus.jpg"
          alt="FAQ Banner"
          className="absolute inset-0 w-full h-full object-cover brightness-50"
        />
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4">FAQs</h1>
          <p className="text-lg md:text-2xl">
            Find answers to common questions about our services and policies.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-5 bg-gray-100">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Frequently Asked Questions</h2>

          <div className="space-y-4">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
                >
                  <span className="text-lg md:text-xl font-semibold">{faq.question}</span>
                  <span className="text-2xl transform transition-transform duration-300">
                    {activeIndex === index ? '-' : '+'}
                  </span>
                </button>
                <div
                  className={`px-6 pb-4 text-gray-700 text-lg transition-all duration-300 ${
                    activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                  }`}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
